<template>
  <div class="settings">
    <div class="content">
      <div class="wrapper">
        <div class="main-wrap">
          <div class="settings-header">
            Settings Dashboard
            <div class="settings-header__btn">
              <el-button type="success" size="mini" @click="routerLink('settings-totalfow-accounts')">totalfow Accounts</el-button>
            </div>
          </div>

          <el-row :gutter="10" type="flex" justify="space-around" style="margin-bottom: 20px;">
            <!-- Organisation Information -->
            <el-col :span="4" :offset="0" class="item">
              <div class="item__title">Organisation Information</div>
              <div class="item__btn">
                <el-button size="small" style="width: 60%;">About</el-button>
              </div>
              <h4 style="margin-bottom: 5px;">Global</h4>
              <div class="item__link" @click="routerLink('settings-information-general')">General</div>
              <!-- <div class="item__link" @click="routerLink('settings-information-business')">Business</div> -->
              <div class="item__link" @click="underDevelopment">Owners</div>
              <div class="item__link" @click="underDevelopment">Directors & Office</div>
              <h4 style="margin-bottom: 5px;">Regional</h4>
              <div class="item__link" @click="routerLink('settings-information-accounting')">Business & Accounting</div>
              <div class="item__link" @click="routerLink('settings-information-taxation')">Taxation</div>
              <div class="item__link" @click="routerLink('settings-information-report')">Reporting</div>
              <div class="item__link" v-if="isPhilippines" @click="routerLink('settings-information-statutory')">Statutory</div>
              <!-- <div class="item__link" @click="routerLink('settings-information-expanded')">Expanded</div> -->
            </el-col>
            <!-- Organisation Permissions -->
            <el-col :span="4" :offset="0" class="item">
              <div class="item__title">Organisation Permissions</div>
              <div class="item__btn">
                <el-button size="small" style="width: 60%;">About</el-button>
              </div>
              <div
                  class="item__link"
                  :class="{disabled: !companyLayout.permission.viewPermissionsPressets}"
                  @click="companyLayout.permission.viewPermissionsPressets ? routerLink('settings-permissions-company') : null">Company</div>
              <div
                  class="item__link"
                  @click="underDevelopment">Data Rooms</div>
              <div
                  class="item__link"
                  :class="{disabled: !companyLayout.permission.viewPermissionsPressets}"
                  @click="companyLayout.permission.viewPermissionsPressets ? routerLink('settings-permissions-business-units') : null">Business Units</div>
              <div
                  class="item__link"
                  @click="underDevelopment">Warehouses</div>
              <div
                  class="item__link"
                  :class="{disabled: !companyLayout.permission.viewPermissionsPressets}"
                  @click="companyLayout.permission.viewPermissionsPressets ? routerLink('settings-permissions-engagements') : null">Engagements</div>
              <div
                  class="item__link"
                  :class="{disabled: !companyLayout.permission.viewPermissionsPressets}"
                  @click="companyLayout.permission.viewPermissionsPressets ? routerLink('settings-permissions-projects') : null">Projects</div>
            </el-col>
            <!-- Organisation Design -->
            <el-col :span="4" :offset="0" class="item">
              <div class="item__title">Organisation Design</div>
              <div class="item__btn">
                <el-button size="small" style="width: 60%;">About</el-button>
              </div>
              <div class="item__link" @click="underDevelopment">Hierarchy</div>
              <div class="item__link" @click="routerLink('settings-data-rooms')">Data Rooms</div>
              <div class="item__link" @click="routerLink('settings-coa')">Chart of Accounts</div>
              <div class="item__link" @click="routerLink('settings-compliance')">Compliance</div>
              <!-- <div class="item__link" @click="routerLink('settings-tax-accounts')">Tax Accounts</div> -->
              <div class="item__link" @click="routerLink('settings-tax-libraries')">Tax Libraries</div>
              <div class="item__link" @click="routerLink('settings-business-centers')">Business Centres</div>
              <div class="item__link" @click="routerLink('settings-business-units')">Business Units</div>
              <div class="item__link" @click="routerLink('settings-warehouse-types')">Warehouse</div>
              <div class="item__link" @click="routerLink('settings-engagement-types')">Engagement Types</div>
              <div class="item__link" @click="routerLink('settings-project-types')">Project Types</div>
              <div class="item__link" @click="routerLink('settings-regions')">Regions</div>
              <div class="item__link" @click="routerLink('settings-progress-billing')">Progress Billing</div>
              <div class="item__link" @click="underDevelopment">Reports</div>
            </el-col>
            <!-- AccountTHINK -->
            <el-col :span="4" :offset="0" class="item">
              <div class="item__title">TF Accounting</div>
              <div class="item__btn">
                <el-button size="small" style="width: 60%;">About</el-button>
              </div>
              <div class="item__link" @click="routerLink('settings-items')">Items (Assets)</div>
              <!-- <div class="item__link" @click="routerLink('settings-items-table')">Items</div> -->
              <div class="item__link" @click="routerLink('settings-payment-methods')">Payment Methods</div>
              <div class="item__link" @click="routerLink('settings-bank-account-types')">Bank Account Types</div>
              <div class="item__link" @click="routerLink('settings-payment-types')">Payment Types</div>
              <div class="item__link" @click="routerLink('settings-payment-terms')">Payment Terms</div>
              <div class="item__link" @click="routerLink('settings-bank-accounts')">Bank Accounts</div>
              <div class="item__link" @click="underDevelopment">Cash on Hand</div>
              <div class="item__link" @click="underDevelopment">Revolving Funds</div>
              <div class="item__link" @click="underDevelopment">Petty Cash Funds</div>
              <div class="item__link" @click="underDevelopment">Undeposited Collections</div>
              <div class="item__link" @click="underDevelopment">Cash Advances Employees</div>
              <div class="item__link" @click="underDevelopment">Cash Advances Others</div>
              <div class="item__link" @click="routerLink('settings-credit-cards-accounts')">Credit Card Accounts</div>
              <div class="item__link" @click="underDevelopment">Employee Reimbursements</div>
              <!-- <div class="item__link" @click="routerLink('settings-open-balance-items')">Open Balance Items</div> -->
              <div class="item__link" @click="routerLink('settings-opening-balance-equity')">Opening Balance Equity</div>
              <div class="item__link" @click="underDevelopment">Manage Linked Accounts</div>
              <div class="item__link" @click="routerLink('settings-general-journal-entries')">General Journal Entries</div>
            </el-col>
            <!-- SCM -->
            <el-col :span="4" :offset="0" class="item">
              <div class="item__title">SCM</div>
              <div class="item__btn">
                <el-button size="small" style="width: 60%;">About</el-button>
              </div>
              <div class="item__link" @click="underDevelopment">Vendor Tags</div>
              <!-- <div class="item__link" @click="routerLink('settings-units')">Units</div> -->
              <div class="item__link" @click="routerLink('settings-units-of-measure')">Units of Measure</div>
              <!-- <div class="item__link" @click="routerLink('settings-items-scm')">Items</div> -->
              <div class="item__link" @click="routerLink('settings-items-table')">Items</div>
              <div class="item__link" @click="routerLink('settings-goods')">Items (Type of Goods)</div>
              <div class="item__link" @click="underDevelopment">Item Custom Fields</div>
              <div class="item__link" @click="underDevelopment">Item Discounts & Charges Table</div>
              <div class="item__link" @click="underDevelopment">Discounts & Charges Custom Fields</div>
              <div class="item__link" @click="underDevelopment">Barcode Symbologies</div>
              <div class="item__link" @click="routerLink('settings-shipping-method')">Shipping Methods</div>
              <div class="item__link" @click="underDevelopment">Vendors Canvas Sheets</div>
              <div class="item__link" @click="underDevelopment">Billers Canvas Sheets</div>
              <div class="item__link" @click="routerLink('settings-brands')">Brands</div>
              <div class="item__link" @click="underDevelopment">Forms</div>
              <div class="item__link" @click="underDevelopment">Vendor Custom Fields</div>
              <div class="item__link" @click="underDevelopment">Biller Custom Fields</div>
              <div class="item__link" @click="routerLink('settings-open-balance-items')">Open Balance Inventory</div>
            </el-col>
          </el-row>

          <el-row :gutter="10" type="flex" justify="space-around">
            <!-- CRM -->
            <el-col :span="4" :offset="0" class="item">
              <div class="item__title">CRM</div>
              <div class="item__btn">
                <el-button size="small" style="width: 60%;">About</el-button>
              </div>
              <div class="item__link" @click="underDevelopment">Client Tags</div>
              <div class="item__link" @click="underDevelopment">Client Assessment Sheet</div>
              <div class="item__link" @click="underDevelopment">Items</div>
              <div class="item__link" @click="underDevelopment">Create Item Promotions</div>
              <div class="item__link" @click="routerLink('settings-create-categories-group')">Categories Group</div>
              <div class="item__link" @click="routerLink('settings-item-categories')">Item Categories</div>
              <div class="item__link" @click="underDevelopment">Create Categories Price Levels</div>
              <div class="item__link" @click="underDevelopment">Client Custom Fields</div>
            </el-col>
            <!-- People & Culture -->
            <el-col :span="4" :offset="0" class="item">
              <div class="item__title">People & Culture</div>
              <div class="item__btn">
                <el-button size="small" style="width: 60%;">About</el-button>
              </div>
              <div class="item__link" @click="underDevelopment">Position</div>
              <div class="item__link" @click="underDevelopment">Work Status</div>
              <div class="item__link" @click="routerLink('settings-work-periods')">Work periods</div>
              <div class="item__link" @click="routerLink('settings-work-items')">Work Items</div>
              <div class="item__link" @click="routerLink('settings-work-schedules')">Work Schedules</div>
              <div class="item__link" @click="routerLink('settings-leave-management')">Leave Management</div>
              <div class="item__link" @click="routerLink('settings-payroll')">Payroll</div>
            </el-col>
            <!-- Document Management -->
            <el-col :span="4" :offset="0" class="item">
              <div class="item__title">Document Management</div>
              <div class="item__btn">
                <el-button size="small" style="width: 60%;">About</el-button>
              </div>
              <div class="item__link" @click="underDevelopment">Position Descriptions</div>
              <div class="item__link" @click="routerLink('settings-sop')">SOP's</div>
              <div class="item__link" @click="routerLink('settings-policy')">Policies</div>
              <div class="item__link" @click="routerLink('settings-healthSafety')">Health & Safety</div>
              <div class="item__link" @click="routerLink('settings-commercial')">Commercial</div>
              <div class="item__link" @click="routerLink('settings-general')">General</div>
              <div class="item__link" @click="routerLink('user-signing-status')">User Signing Status</div>
            </el-col>
            <!-- Task Tree Templates -->
            <el-col :span="4" :offset="0" class="item">
              <div class="item__title">Task Tree Templates</div>
              <div class="item__btn">
                <el-button size="small" style="width: 60%;">About</el-button>
              </div>
              <div class="item__link" @click="underDevelopment">Data Room Templates</div>
              <div class="item__link" @click="routerLink('settings-businessUnit-templates')">Business Unit Templates</div>
              <div class="item__link" @click="underDevelopment">Warehouse Templates</div>
              <div class="item__link" @click="routerLink('settings-engagement-templates')">Engagement Templates</div>
              <div class="item__link" @click="routerLink('settings-project-templates')">Project Templates</div>
            </el-col>
            <!-- Email Management -->
            <el-col :span="4" :offset="0" class="item">
              <div class="item__title">Email Management</div>
              <div class="item__btn">
                <el-button size="small" style="width: 60%;">About</el-button>
              </div>
              <div
                class="item__link"
                :class="{disabled: !companyLayout.permission.viewCompanyMailTemplates}"
                @click="companyLayout.permission.viewCompanyMailTemplates ? routerLink('settings-mail-template') : null">Email Templates</div>
            </el-col>
          </el-row>

          <sweet-modal title="tf Support" width="500" blocking ref="support">
            <div class="tf-support">
              <div>Sorry, this feature now under development will be ready later.</div>
            </div>
          </sweet-modal>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
let moment = require('moment');
import { SweetModal } from '@totalflow4/tfsweet-modal-vue'

export default {
  name: 'SettingsDashboard',
  components: {
    SweetModal,
  },
  created () {
    let loader = this.$loading.show();
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
    axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
    axios
      .get(`/api/v1/companies/directoriesCompanyAdditionalInfo?companyId=${this.$route.query.companyId}`)
      .then(response => {
        this.isPhilippines = response.data.data.isPhilippines
        loader.hide()
      })
      .catch(error => {
        console.log('An error occurred:', error);
        loader.hide()
      });
  },
  computed: {
    companyLayout() {
      return this.$store.getters.getCompanyLayout
    },
  },
  data() {
    return {
      isPhilippines: false,
    }
  },
  methods: {
    routerLink(page) {
      this.$router.push({name: page, query: { companyId: this.$route.query.companyId}} )
    },
    underDevelopment() {
      this.$refs.support.open()
    },
  },
}
</script>

<style lang="scss" scoped>
.settings {
  background: #DfE8F0;
}

.content {
  display: flex;
  min-height: 100vh;
  padding-top: 50px;
  .wrapper{
    background: #fff;
    margin: 10px;
    width: 100%;
    display: flex;
    justify-content: center;
    .main-wrap {
      padding: 20px;
      width: 100%;
      // max-width: 1500px;
    }
    &.animation{
      margin-left: 260px;
      transition: margin-left 500ms ease-out, transform 500ms ease-out;
    }
  }
}

.item {
  // text-align: center;
  &__title {
    text-transform: uppercase;
    font-size: 20px;
    font-weight: bold;
    color: #409EFF;
    margin-bottom: 15px;
  }
  &__btn {
    margin-bottom: 20px;
  }
  &__link {
    margin-bottom: 8px;
    &:hover {
      color: #409EFF;
      cursor: pointer;
    }
  }
}
</style>

<style lang="scss">
.settings-header {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 38px;
  padding: 0px 0px 20px;
  margin-bottom: 20px;
  border-bottom: 1px solid #ccc;
  font-weight: bold;
  font-size: 18px;
  &__btn {
    position: absolute;
    right: 0;
    top: auto;
    bottom: auto;
  }
}
</style>
